/*! License details at fancyapps.com/license */
var t = function t(_t) {
  return "string" == typeof _t;
};
export { t as isString };